export const SURFACES_OPTIONS_PANEL = 'surfacesOptionsPanel'
export const ACCESSORIES_OPTIONS_PANEL = 'accessoriesOptionsPanel'
export const METAS_OPTIONS_PANEL = 'metasOptionsPanel'
export const OPTIONAL_BASE_PARTS_PANEL = 'optionalBasePartsPanel'

export const IMG_SIZE_100_100_FIT = '/100x100/FIT'
export const IMG_SIZE_250_250_FIT = '/250x250/FIT'

export const MAX_WORD_LENGTH = 4
